<template>
    <MainLayout>
        <div class="pagetitle">
            <h1>Usuarios</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/">
                            <span>Dashboard</span>
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Usuarios</li>
                </ol>
            </nav>
        </div>

        <section class="section dashboard">

            <div class="card">

                <div class="card-header py-3">

                    <div class="row">

                        <h3 class="m-0 font-weight-bold text-primary col-md-11">Usuarios</h3>

                        <div class="col-md-1" v-if="validatePermission('add_users')">
                            <button @click="openCreateUserModal" class="btn btn-primary"><i
                                    class="bi bi-plus-circle"></i></button>
                        </div>

                    </div>

                </div>

                <div class="card-body mt-2">

                    <Atom1Loader v-if="loading" />

                    <table class="table" v-else>
                        <thead>
                            <tr>
                                <th scope="col">Nombres</th>
                                <th scope="col">Apellidos</th>
                                <th scope="col">Email</th>
                                <th scope="col">Documento</th>
                                <th scope="col">Teléfono</th>
                                <th scope="col">Rol</th>
                                <th scope="col" class="table-buttons"></th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="user in users" :key="user.id">
                                <td>{{ user.first_name }}</td>
                                <td>{{ user.last_name }}</td>
                                <td>{{ user.email }}</td>
                                <td>{{ user.document }}</td>
                                <td>{{ user.phone }}</td>
                                <td>{{ user.role_name }}</td>
                                <td class="table-buttons">
                                    <button @click="openEditUserModal(user)" class="btn btn-sm btn-warning"
                                        v-if="validatePermission('edit_users')" style="margin-right: 0.5em;">
                                        <i class="bi bi-pencil-fill"></i>
                                    </button>
                                    <button v-if="validatePermission('delete_users')"
                                        class="btn btn-danger btn-sm btnDelete" @click="deleteUser(user.id)"><i
                                            class="bi bi-trash-fill"></i></button>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <ModalComponent ref="createUserModal" modalId="createUserModal" title="Nuevo Usuario"
                        @modalClosed="createUserModalClosed" key="k_createUserModal">
                        <!-- <template v-slot:body> -->
                        <template #body>
                            <UserManagerComponent type="C" @userCreated="userCreated" />
                        </template>
                    </ModalComponent>

                    <ModalComponent ref="editUserModal" modalId="editUserModal" title="Editar Usuario"
                        @modalClosed="editUserModalClosed" key="k_editUserModal">
                        <!-- <template v-slot:body> -->
                        <template #body>
                            <UserManagerComponent ref="editUserComponent" type="E" @userUpdated="userUpdated" />
                        </template>
                    </ModalComponent>

                    <!-- Create user Modal -->
                    <!-- <div class="modal fade" ref="createUserModal" tabindex="-1">
                        <div class="modal-dialog modal-xl">
                            <div class="modal-content">

                                <div class="modal-header">
                                    <h3 class="modal-title" id="createUserModalLabel">Crear Usuario</h3>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>

                                <div class="modal-body">                                    
                                    <UserManagerComponent type="C" />
                                </div>

                                div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button type="button" class="btn btn-primary">Save changes</button>
                                </div>

                            </div>
                        </div>
                    </div> -->

                </div>
            </div>
        </section>
    </MainLayout>
</template>

<script>
import MainLayout from '../../../layouts/MainLayout';
import toastMixin from '../../../mixins/toastMixin';
import accountMixin from '../../../mixins/accountMixin';
// import UserManagerComponent from '../../../components/Admin/Users/UserManagerComponent.vue';
import UserManagerComponent from '@/components/Admin/Users/UserManagerComponent.vue';
import ModalComponent from '@/components/Utils/ModalComponent.vue';
import axios from "axios";
import { checkCatch } from "../../../utils";

import Atom1Loader from '@/components/Utils/Loaders/Atom1Loader.vue';

export default {

    mixins: [toastMixin, accountMixin],

    name: 'Users',

    components: {
        MainLayout,
        UserManagerComponent,
        ModalComponent,
        Atom1Loader,
    },

    data() {

        return {

            loading: false,
            users: [],
        };
    },

    async mounted() {

        await this.getUsers();
        // console.log(this.$env.API_BASE_URL)
        // console.log(this.$env.ENV)
    },

    methods: {

        async getUsers() {

            this.loading = true;

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };

            await axios.get(`${this.$env.API_BASE_URL}users/`, { headers })
                .then((response) => {

                    this.users = response.data.map(item => {

                        const user = {
                            id: item.id,
                            first_name: item.first_name,
                            last_name: item.last_name,
                            email: item.email,
                            role_name: item.role_name,
                            role: item.role,
                            document: item.extra_data.document,
                            phone: item.extra_data.phone,
                        };

                        return user;
                    });

                    this.loading = false;

                }).catch((error) => {

                    checkCatch(error);
                });
        },

        openCreateUserModal() {

            this.$refs.createUserModal.openModal();
            // const modal = this.$refs.createUserModal

            // console.log($(modal))

            // Inicializa el modal usando la API de Bootstrap 5
            // const bootstrapModal = new Modal(modal);
            // bootstrapModal.show();
        },

        openEditUserModal(user) {

            this.$refs.editUserModal.openModal();
            this.$refs.editUserComponent.setUser(user);
        },

        async userCreated() {

            this.$refs.createUserModal.closeModal();
            await this.getUsers();
        },

        async userUpdated() {

            this.$refs.editUserModal.closeModal();
            await this.getUsers();
        },

        createUserModalClosed() {

        },

        editUserModalClosed() {

        },

        deleteUser(id) {

            // Use sweetalert2
            // this.$swal('Hello Vue world!!!');
            // this.$swal('Heading', 'this <strong>IS</strong> a Heading', 'success');

            // this.$swal({
            //     title: 'What is your Name?',
            //     input: 'text',
            //     inputPlaceholder: 'Enter your name here',
            //     showCloseButton: true,
            //     icon: 'question'
            // });

            this.$swal({

                title: '¿Desea eliminar el usuario?',
                text: 'No podrá revertirlo',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                showCloseButton: true,
                // showLoaderOnConfirm: true,
                icon: 'warning',
            }).then((result) => {

                if (result.value) {

                    this.loading = true;

                    const headers = {

                        'Authorization': `Bearer ${this.accountUser.token}`
                    };

                    axios.delete(`${this.$env.API_BASE_URL}users/delete/${id}/`, { headers })
                        .then(() => {

                            let index = this.users.findIndex(item => item.id === id);

                            if (index !== -1) {

                                this.users.splice(index, 1); // Elimina 1 elemento en el índice encontrado
                            }

                            this.showNotification({
                                title: 'Éxito',
                                description: 'Usuario eliminado con éxito',
                                timeout: 4,
                            });

                            this.loading = false;

                        }).catch((error) => {

                            checkCatch(error);
                        });
                }
            });
        },
    },
};
</script>